import { useEffect, useState } from "preact/hooks";

export type ToastKind = "success" | "error" | "warning";

interface ToastItem {
  id: number;
  kind: ToastKind;
  message: string;
}

let counter = 0;
let items: ToastItem[] = [];
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((fn) => fn());
}

function push(kind: ToastKind, message: string): void {
  counter += 1;
  const item: ToastItem = { id: counter, kind, message };
  items = [...items, item];
  emit();
  setTimeout(() => {
    items = items.filter((i) => i.id !== item.id);
    emit();
  }, 5000);
}

export const toast = {
  success: (message: string) => push("success", message),
  error: (message: string) => push("error", message),
  warning: (message: string) => push("warning", message),
};

function dismiss(id: number): void {
  items = items.filter((i) => i.id !== id);
  emit();
}

export function ToastHost() {
  const [, tick] = useState(0);
  useEffect(() => {
    const fn = () => tick((t) => t + 1);
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);

  if (items.length === 0) return null;

  const glyph: Record<ToastKind, string> = { success: "✓", error: "!", warning: "!" };

  return (
    <div class="toast-host" role="status" aria-live="polite">
      {items.map((item) => (
        <div key={item.id} class={`toast toast--${item.kind}`}>
          <span class="toast__icon" aria-hidden="true">
            {glyph[item.kind]}
          </span>
          <span class="toast__msg">{item.message}</span>
          <button type="button" class="toast__close" onClick={() => dismiss(item.id)} aria-label="Dismiss">
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
